import { fetch } from "../Helper/httpRequest";
const API_HOST = process.env.REACT_APP_API_HOST + "/users/v1";
const API_HOST_RAIN = process.env.REACT_APP_API_HOST + "/rain_card/v1";

const API_HOST_WALLET = process.env.REACT_APP_API_HOST_WALLET + "/wallet/v1";

const checkUserExist = (data) => {
  return fetch("post", `${API_HOST}/user/check-user-exist`, data, {}, {});
};

const generateOTP = (data) => {
  return fetch("post", `${API_HOST}/user/generate-otp`, data, {}, {});
};

const verifyOTP = (data) => {
  return fetch("post", `${API_HOST}/user/verify-otp`, data, {}, {});
};

const setPasswordSignup = (data) => {
  return fetch("post", `${API_HOST}/user/register`, data, {}, {});
};

const unsubscribe = (data) => {
  return fetch(
    "post",
    `${API_HOST}/user/updateStatusUnsubscribe`,
    data,
    {},
    {}
  );
};

const userLogin = (data) => {
  return fetch("post", `${API_HOST}/user/login`, data, {}, {});
};

const forgotEmail = (data) => {
  return fetch("post", `${API_HOST}/user/forgot-password`, data, {}, {});
};

const forgotEmailVerify = (data) => {
  return fetch("post", `${API_HOST}/user/verify-code`, data, {}, {});
};

const resetPassword = (data) => {
  return fetch("post", `${API_HOST}/user/reset-password`, data, {}, {});
};

const getUserInfo = () => {
  return fetch("get", `${API_HOST}/user/user-profile`, {}, {}, {});
};

const getEquityTranscations = (params) => {
  return fetch("get", `${API_HOST}/user/get_equity_transactions`, {}, {}, params);
};

const getUsersInvestment = (params) => {
  return fetch("get", `${API_HOST}/user/user-investments`, {}, {}, params);
};

const getAllAssets = () => {
  return fetch("get", `${API_HOST}/user/dashboard/all-assets`, {}, {});
};

const getMarketplaceFee = () => {
  return fetch("get", `${API_HOST}/user/fetch-marketplace-fee`, {}, {});
};
const getUserProfit = () => {
  return fetch("get", `${API_HOST}/user/getUserProfit`, {}, {});
};

const logoutUser = (accessToken) => {
  return fetch(
    "get",
    `${API_HOST}/user/logout`,
    {},
    {},
    { token: accessToken }
  );
};

const updateUserInfo = (data) => {
  return fetch("post", `${API_HOST}/user/update-profile`, data, {}, {});
};

const deactivateAccount = () => {
  return fetch("post", `${API_HOST}/user/deactivate-account`, {}, {}, {});
};

const uploadProfile = (data) => {
  return fetch("post", `${API_HOST}/user/upload-profile`, data, {}, {});
};

const getUserTransactions = (data) => {
  return fetch("get", `${API_HOST}/user/transactions`, {}, {}, data);
};

const getUserTransactionDetails = (data) => {
  return fetch("post", `${API_HOST}/user/transactions/detail`, data, {}, {});
};

const getTransactionExport = (data) => {
  return fetch("get", `${API_HOST}/user/transactions/export`, {}, {}, data);
};

const getInvoiceDownload = (data) => {
  return fetch("post", `${API_HOST}/user/invoice/download`, data, {}, {});
};

const getRecentTransactionsDashboard = () => {
  return fetch(
    "get",
    `${API_HOST}/user/transactions/recent-transactions`,
    {},
    {},
    {}
  );
};

const getDashboardGraphData = (params) => {
  return fetch("get", `${API_HOST}/user/dashboard/graph`, {}, {}, params);
};

const getSpotPrice = (data) => {
  return fetch("post", `${API_HOST}/user/get-price`, data, {}, {});
};

const getTokenBalance = (data) => {
  return fetch("get", `${API_HOST}/user/token/balance`, {}, {}, data);
};
const getnotificationReadStatus = (data) => {
  return fetch(
    "get",
    `${API_HOST}/user/getnotificationReadStatus
  `,
    {},
    {},
    data
  );
};

const redeemAsset = (data) => {
  return fetch("post", `${API_HOST}/user/dashboard/redeem-asset`, data, {}, {});
};

const getPortfolioBalance = (params) => {
  return fetch(
    "get",
    `${API_HOST}/user/dashboard/portfolio-balance`,
    {},
    {},
    params
  );
};
const getUserCoinList = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/coin_list`,
    {},
    {},
    params
  );
};

const getActiveCoin = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/coin_list_active`,
    {},
    {},
    params
  );
};
const getDepositHistory = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/history/deposit`,
    {},
    {},
    params
  );
};
const getWithdrawHistory = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/history/withdraw`,
    {},
    {},
    params
  );
};
const getCryptoBalance = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/wallet_balance`,
    {},
    {},
    params
  );
};

const generateAccount = (data) => {
  return fetch(
    "post",
    `${API_HOST_WALLET}/wallet/user/generate_account`,
    data,
    {},
    {}
  );
};

const withdrawRequest = (data) => {
  return fetch(
    "post",
    `${API_HOST_WALLET}/wallet/user/withdraw_request`,
    data,
    {},
    {}
  );
};

const cancelRequest = (data) => {
  return fetch(
    "post",
    `${API_HOST_WALLET}/wallet/user/cancel_request`,
    data,
    {},
    {}
  );
};

const getShipstationCarriers = (params) => {
  return fetch(
    "get",
    `${API_HOST}/user/shipstation/carriers/list`,
    {},
    {},
    params
  );
};
const getUserAllNotification = (params) => {
  return fetch(
    "get",
    `${API_HOST}/user/getUserAllNotification`,
    {},
    {},
    params
  );
};

const getShipstationRates = (data) => {
  return fetch("post", `${API_HOST}/user/shipstation/get-rates`, data, {}, {});
};

const getPremiumFee = () => {
  return fetch("get", `${API_HOST}/user/premium-fee`, {}, {}, {});
};

const getUserWalletBalance = () => {
  return fetch("get", `${API_HOST}/user/wallet/balance`, {}, {}, {});
};

const getUserWalletLedgerList = (params) => {
  return fetch("get", `${API_HOST}/user/wallet/ledger`, {}, {}, params);
};

const addWireFund = (data) => {
  return fetch("post", `${API_HOST}/user/add/wire-fund`, data, {}, {});
};

const getBuySellOrdersList = (params) => {
  return fetch("get", `${API_HOST}/user/ptop/list`, {}, {}, params);
};

const getUserBuySellOrdersList = (params) => {
  return fetch("get", `${API_HOST}/user/ptop/orders`, {}, {}, params);
};

const createBuyOrder = (data) => {
  return fetch("post", `${API_HOST}/user/ptop/order/create`, data, {}, {});
};

const cancelUserOrder = (data) => {
  return fetch("post", `${API_HOST}/user/ptop/order/cancel`, data, {}, {});
};

const matchP2POrder = (data) => {
  return fetch("post", `${API_HOST}/user/ptop/order/match`, data, {}, {});
};

const getUserOrdersHistory = (params) => {
  return fetch("get", `${API_HOST}/user/ptop/history`, {}, {}, params);
};

const getPtpOrderDetail = (data) => {
  return fetch("post", `${API_HOST}/user/ptop/order/detail`, data, {}, {});
};

const convertCoin = (data) => {
  return fetch("post", `${API_HOST}/user/token/convert`, data, {}, {});
};

const convertToStableCoin = (data) => {
  return fetch(
    "post",
    `${API_HOST}/user/token/convert-to-stablecoin`,
    data,
    {},
    {}
  );
};

const userWalletBalance = (data) => {
  return fetch("get", `${API_HOST}/user/fiat/wallet/balance`, {}, {}, {});
};

const userWalletHistory = (data) => {
  return fetch("get", `${API_HOST}/user/fiat/wallet/ledger`, {}, {}, data);
};

const getSellWithUsTokenPrices = (params) => {
  return fetch("get", `${API_HOST}/user/sell_with_us/price`, {}, {}, params);
};

const createSellWithUsP2POrder = (data) => {
  return fetch(
    "post",
    `${API_HOST}/user/sell_with_us/order/create`,
    data,
    {},
    {}
  );
};

const userSellWithUsHistory = (params) => {
  return fetch("get", `${API_HOST}/user/sell_with_us/history`, {}, {}, params);
};

const userSellWithUs = (params) => {
  return fetch("get", `${API_HOST}/user/sell_with_us/orders`, {}, {}, params);
};

const cancelSellWithUs = (data) => {
  return fetch(
    "post",
    `${API_HOST}/user/sell_with_us/order/cancel`,
    data,
    {},
    {}
  );
};

const addBankDetails = (data) => {
  return fetch("post", `${API_HOST}/user/add/bank_detail`, data, {}, {});
};

const editBankDetails = (data) => {
  return fetch("post", `${API_HOST}/user/update/bank_detail`, data, {}, {});
};

const buyEquityTokens = (data) => {
  return fetch("post", `${API_HOST}/user/buy_equity_tokens`, data, {}, {});
};

const deleteBankDetails = () => {
  return fetch("delete", `${API_HOST}/user/delete/bank_detail`, {}, {}, {});
};

const getBankDetails = (params) => {
  return fetch("get", `${API_HOST}/user/fetch/bank_detail`, {}, {}, params);
};

const generateWithdrawOTP = (data) => {
  return fetch("post", `${API_HOST}/user/generate-withdraw-otp`, data, {}, {});
};
const verifyWithdrawOTP = (data) => {
  return fetch("post", `${API_HOST}/user/verify-withdraw-otp`, data, {}, {});
};

const getFiatWithdrawList = (params) => {
  return fetch(
    "get",
    `${API_HOST}/user/fiat/wallet/withdraw/list`,
    {},
    {},
    params
  );
};
const userBalanceReport = (params) => {
  return fetch(
    "get",
    `${API_HOST}/user/user_coin_balance_report`,
    {},
    {},
    params
  );
};
const equityTokenDetails = (params) => {
  return fetch("get", `${API_HOST}/user/get_equity_details`, {}, {}, params);
};

const userTransaction = (params) => {
  return fetch("get", `${API_HOST}/user/transaction_track`, {}, {}, params);
};

const getCoinList = (params) => {
  return fetch("get", `${API_HOST}/user/coin_list_all`, {}, {}, params);
};
const getUserBlncDwnld = (params) => {
  return fetch("get", `${API_HOST}/user/user_balance_download`, {}, {}, params);
};

const cancelWithdrawRequest = (data) => {
  return fetch(
    "post",
    `${API_HOST}/user/fiat/wallet/cancel-withdraw`,
    data,
    {},
    {}
  );
};

const getNotificationData = async (data) => {
  try {
    const response = await fetch(
      "put",
      `${API_HOST}/user/updateReadNotificationStatus`,
      data,
      {},
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteNotificationData = async (data) => {
  try {
    const response = await fetch(
      "put",
      `${API_HOST}/user/deleteUserNotification`,
      data,
      {},
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getBanner = (params) => {
  return fetch("get", `${API_HOST}/user/banner`, {}, {}, params);
};

const getDeposit = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/history/deposit_v2`,
    {},
    {},
    params
  );
};

const getWithdraw = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/history/withdraw_v2`,
    {},
    {},
    params
  );
};

const getPendingDeposits = (params) => {
  return fetch("get", `${API_HOST}/user/pending_deposits`, {}, {}, params);
};

const getCryptoPortfolioValue = (params) => {
  return fetch("get", `${API_HOST}/user/portfolio_balance`, {}, {}, params);
};

const getTransactionBalance = (params) => {
  return fetch(
    "get",
    `${API_HOST_WALLET}/wallet/user/transaction_balance`,
    {},
    {},
    params
  );
};

const getTradingVolume = (params) => {
  return fetch("get", `${API_HOST}/user/trading_volume`, {}, {}, params);
};

const setPriceAlert = (data) => {
  return fetch("post", `${API_HOST}/user/set_price_alert`, data, {}, {});
};

const getPriceAlertList = (params) => {
  return fetch("get", `${API_HOST}/user/price_alert`, {}, {}, params);
};

const deletePriceAlert = (params) => {
  return fetch("delete", `${API_HOST}/user/delete_price_alert`, {}, {}, params);
};
const cardDetails = (data) => {
  return fetch("get", `${API_HOST_RAIN}/rain-card/users/cards`, data, {}, {});
};

const displayPin = (data, rainId) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/pin`,
    data,
    {},
    {}
  );
};
const activeCard = (data, cardId) => {
  return fetch(
    "PATCH",
    `${API_HOST_RAIN}/rain-card/cards/${cardId}`,
    data,
    {},
    {}
  );
};
const cardTranstion = (applicationId, data) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/cards/${applicationId}/transactions`,
    {},
    {},
    data
  );
};
const cardData = (applicationId) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/cards/${applicationId}/details`,
    {},
    {},
    {}
  );
};

const revealSecretPin = (data) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/cards/c2dca66d-aa51-40ea-a709-286acdc29458/secrets`,
    data,
    {},
    {}
  );
};
const initiateApplication = (data) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/initiate-application`,
    data,
    {},
    {}
  );
};
const applyRainCard = (data, applicationId) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/users/${applicationId}/cards`,
    data,
    {},
    {}
  );
};
const applyCardApplication = (data) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/applications/user`,
    data,
    {},
    {}
  );
}

const setUpdatePin = (data, rainId) => {
  return fetch(
    "put",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/pin`,
    data,
    {},
    {}
  );
};

const topUpCard = (data, rainId) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/recharge`,
    data,
    {},
    {}
  );
};

const getOccupationCodes = (data) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/occupation-codes`,
    data,
    {},
    {}
  );
};

const getCardControls = (rainId) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/settings`,
    {},
    {},
    {}
  );
};

const updateCardControls = (data, rainId) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/settings`,
    data,
    {},
    {}
  );
};

const getUnbiledTransactions = (data, rainId) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/unbilled-transactions`,
    {},
    {},
    data
  );
};

const getCardStatement = (data, rainId) => {
  return fetch(
    "get",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/bill`,
    {},
    {},
    data
  );
};

const reportIssue = (data) => {
  return fetch(
    "post",
    `${API_HOST_RAIN}/disputes/submit`,
    data,
    {},
    {}
  );
};

const getGlobalCardSettings = (cardType) => {
  return fetch("get", `${API_HOST_RAIN}/rain-card/global-settings/${cardType}`, {}, {}, {});
};

const updateManageCard = (data, rainId) => {
  return fetch(
    "put",
    `${API_HOST_RAIN}/rain-card/cards/${rainId}/user-settings`,
    data,
    {},
    {}
  );
};

const getViewCard = (rainId, data) => {
  return fetch("post", `${API_HOST_RAIN}/rain-card/cards/${rainId}/secrets`, data, {}, {});
};

const getPayment = () => {
  return fetch("get", `${API_HOST_WALLET}/wallet/user/get-currency-for-payment`, {}, {}, {});
};

const submitPayment = (data) => {
  return fetch("post", `${API_HOST_RAIN}/rain-card/pay-bill`, data, {}, {});
};

const viewStatement = (rainId, data) => {
  return fetch("get", `${API_HOST_RAIN}/rain-card/${rainId}/statement-transactions`, {}, {}, data);
};

const getPaymentTransactions = (rainId, data) => {
  return fetch("get", `${API_HOST_RAIN}/rain-card/${rainId}/payment-history`, {}, {}, data);
};

const getCryptoByFilter = (data) => {
  return fetch("get", `${API_HOST_WALLET}/wallet/user/get-crypto-by-filter`, {}, {}, data);
};

const cancelCard = (rainId, data) => {
  return fetch("patch", `${API_HOST_RAIN}/rain-card/cards/${rainId}`, data, {}, {});
};


export const userService = {
  getActiveCoin,
  getEquityTranscations,
  buyEquityTokens,
  getUserBlncDwnld,
  getCoinList,
  userTransaction,
  userBalanceReport,
  equityTokenDetails,
  getUserProfit,
  getnotificationReadStatus,
  getNotificationData,
  getUserAllNotification,
  deleteNotificationData,
  cancelWithdrawRequest,
  getFiatWithdrawList,
  getBankDetails,
  generateWithdrawOTP,
  verifyWithdrawOTP,
  addBankDetails,
  getCryptoBalance,
  getUserCoinList,
  getDepositHistory,
  getWithdrawHistory,
  generateAccount,
  withdrawRequest,
  cancelRequest,
  getShipstationCarriers,
  cancelSellWithUs,
  userSellWithUs,
  userSellWithUsHistory,
  createSellWithUsP2POrder,
  getSellWithUsTokenPrices,
  createBuyOrder,
  checkUserExist,
  generateOTP,
  userLogin,
  verifyOTP,
  setPasswordSignup,
  unsubscribe,
  forgotEmail,
  forgotEmailVerify,
  resetPassword,
  getUserInfo,
  getUsersInvestment,
  getAllAssets,
  getMarketplaceFee,
  logoutUser,
  updateUserInfo,
  deactivateAccount,
  uploadProfile,
  getUserTransactions,
  getUserTransactionDetails,
  getInvoiceDownload,
  getRecentTransactionsDashboard,
  getDashboardGraphData,
  getSpotPrice,
  getTokenBalance,
  redeemAsset,
  getPortfolioBalance,
  getPremiumFee,
  getShipstationRates,
  getUserWalletBalance,
  getUserWalletLedgerList,
  addWireFund,
  getBuySellOrdersList,
  getUserBuySellOrdersList,
  cancelUserOrder,
  matchP2POrder,
  getUserOrdersHistory,
  getPtpOrderDetail,
  convertCoin,
  convertToStableCoin,
  userWalletBalance,
  userWalletHistory,
  editBankDetails,
  deleteBankDetails,
  getTransactionExport,
  getBanner,
  getDeposit,
  getWithdraw,
  getPendingDeposits,
  getCryptoPortfolioValue,
  getTransactionBalance,
  getTradingVolume,
  setPriceAlert,
  getPriceAlertList,
  deletePriceAlert,
  cardDetails,
  displayPin,
  activeCard,
  cardTranstion,
  cardData,
  revealSecretPin,
  initiateApplication,
  applyRainCard,
  applyCardApplication,
  setUpdatePin,
  topUpCard,
  getOccupationCodes,
  getCardControls,
  updateCardControls,
  getUnbiledTransactions,
  getCardStatement,
  reportIssue,
  getGlobalCardSettings,
  updateManageCard,
  getViewCard,
  getPayment,
  submitPayment,
  viewStatement,
  getPaymentTransactions,
  getCryptoByFilter,
  cancelCard
};
